// extracted by mini-css-extract-plugin
export default {"pagination":"style_pagination__g0D74","pageNumber":"style_pageNumber__JvqW8","pageActive":"style_pageActive__ETC80"};